import { FSharpException, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { defaultArgWith } from "../fable_modules/fable-library-js.4.24.0/Option.js";

export class ServerError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Internal", "Unauthorized"];
    }
}

export function ServerError_$reflection() {
    return union_type("Shared.Errors.ServerError", [], ServerError, () => [[], []]);
}

export class ServerException extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function ServerException_$reflection() {
    return class_type("Shared.Errors.ServerException", undefined, ServerException, class_type("System.Exception"));
}

export function ServerErrorModule_failwith(error) {
    throw new ServerException(error);
}

export function ServerErrorModule_requireSome(error, o) {
    return defaultArgWith(o, () => ServerErrorModule_failwith(error));
}

//# sourceMappingURL=Errors.jsx.map
